import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import {
  productsReturn,
  ReturnDisposalDetailState
} from '@root/state/reducers/return_disposal/returnDisposalReducer';
import { Form, Spin } from 'antd';
import OrderForm from '../components/OrderForm';
import ProductForm from '../components/ProductForm';
import ProgressForm from '../components/ProgressForm';
import RecipientForm from '../components/RecipientForm';
import { useEffect, useMemo, useRef } from 'react';
import returnDisposalService from '../../Return/Service/returnDisposal';
import recipient from '@modules/Sellers/Return/components/Recipient/Recipient';
import { useLocation } from 'react-router';

interface ReturnOrderPageProps {
  canEdit?: boolean;
  doneEdit?: () => void;
  commentId?: number;
  showInspectionStatus?: boolean;
  showProcessType?: boolean;
}
const ReturnOrderPage = ({
  canEdit,
  doneEdit,
  commentId,
  showInspectionStatus,
  showProcessType
}: ReturnOrderPageProps) => {
  const { detailData, detailLoading } =
    useTypedSelector<ReturnDisposalDetailState>(
      (state) => state.returnDisposalDetailReducer
    );
  // order
  const order = detailData?.data?.order;
  const location = useLocation();
  const childRef: any = useRef(null);

  // Products
  const products = detailData?.data?.orderProducts?.products;

  const [formProduct] = Form.useForm();
  const [formRecipient] = Form.useForm();

  const save = async () => {
    if (!location.pathname.includes('returnDelivery')) {
      if (doneEdit && commentId) {
        const products: any[] = [];
        Object.keys(formProduct.getFieldsValue()).map((key) =>
          products.push(formProduct.getFieldsValue()[key])
        );

        await returnDisposalService.updateReturn(
          products,
          formRecipient.getFieldsValue(),
          commentId,
          detailData.data.id
        );

        doneEdit();
      }
    } else {
      childRef?.current?.submit();
    }
  };

  useEffect(() => {
    formProduct.setFieldsValue(products);
  }, [formProduct, products]);

  return (
    <Spin spinning={detailLoading} className="loading-forgot">
      <div
        className="orderForm"
        style={{
          background: 'white',
          padding: '20px',
          margin: '20px',
          marginBottom: 0
        }}
      >
        {detailData?.data?.status && !canEdit && (
          <div>
            <p
              style={{
                marginBottom: '0px',
                fontWeight: 'bold',
                fontSize: '15px',
                width: '150px',
                marginLeft: 'auto',
                display: 'block',
                borderRadius: '20px',
                padding: '6px 0px',
                background: '#2B2C51',
                color: 'white',
                textAlign: 'center'
              }}
            >
              {showProcessType ? (
                <span style={{ textTransform: 'capitalize' }}>
                  {detailData?.data?.processType}
                </span>
              ) : (
                detailData?.data?.status
              )}
            </p>
          </div>
        )}
        {canEdit && (
          <div>
            <p
              style={{
                marginBottom: '0px',
                fontWeight: 'bold',
                fontSize: '15px',
                width: 'max-content',
                height: '30px',
                marginLeft: 'auto',
                display: 'block',
                padding: '6px 0px',
                color: 'black',
                textAlign: 'center',
                borderBottom: '1px solid black',
                cursor: 'pointer'
              }}
              onClick={() => save()}
            >
              SAVE
            </p>
          </div>
        )}
        <div
          style={{
            padding: '10px 30px',
            marginRight: '30px',
            borderRadius: '10px'
          }}
        >
          <OrderForm edit={true} orderForm={order} />
        </div>
        <div>
          <ProductForm
            form={formProduct}
            edit={canEdit}
            productsArr={products}
            warehouseName={detailData?.data?.warehouseName}
          />
        </div>

        <div style={{ padding: '10px 30px' }}>
          <RecipientForm
            form={formRecipient}
            edit={canEdit}
            detailData={detailData?.data}
          />
        </div>
        {canEdit && !location.pathname.includes('returnDelivery') ? (
          <></>
        ) : (
          <ProgressForm
            ref={childRef}
            detailData={{
              ...detailData?.data,
              deliveryStatus: detailData?.data?.returnStatus
            }}
            showInspectionStatus={showInspectionStatus}
            isChange={canEdit && location.pathname.includes('returnDelivery')}
          />
        )}
      </div>
    </Spin>
  );
};

export default ReturnOrderPage;
